import { Field } from 'react-final-form'
import FinalFormInputMask from '../InputMask'

export default function FormInputMask(props) {
  const { name } = props
  return <Field name={name} component={FinalFormInputMask} {...props} />
}
